import GenericCard from "widgets/cards/generic";
import SetupForm from "widgets/forms/reports/setup";
import { useTranslation } from "react-i18next";

interface MyDocumentProps {
  onData: (data: any) => void;
}

const Configuration: React.FC<MyDocumentProps> = ({ onData }) => {
  const { t } = useTranslation();
  return (
    <GenericCard
      title={t("reports.adhoc.configuration.title")}
      description={t("reports.adhoc.configuration.description")}
      bgColor="400"
      textColor="white"
      extra="h-full"
    >
      <SetupForm
        submit={(data) => {
          onData(data);
        }}
      />
    </GenericCard>
  );
};

export default Configuration;
